import React from "react";

import { Typography } from "antd";
import { cx } from "class-variance-authority";

import { InfoTooltip } from "../infoTooltip/tooltip";

import * as theme from "./theme.css";

const { Title } = Typography;

type StyleVariant = "primary" | "secondary";
const rootStyleVariantMap: Record<StyleVariant, string> = {
    primary: theme.primaryVariant,
    secondary: theme.secondaryVariant,
};
const titleStyleVariantMap: Record<StyleVariant, string | undefined> = {
    primary: undefined,
    secondary: theme.secondaryTitleVariant,
};
const titleLevelVariantMap: Record<StyleVariant, 4 | 5> = {
    primary: 4,
    secondary: 5,
};

interface FormSectionProps {
    id?: string;
    titleLabel?: string;
    children: React.ReactNode;
    withDivider?: boolean;
    tooltip?: string;
    className?: string;
    styleVariant?: StyleVariant;
    stickyContent?: boolean;
    headingRight?: React.ReactNode;
}

export const FormSection = ({
    id,
    titleLabel,
    children,
    tooltip,
    className,
    withDivider = false,
    stickyContent = false,
    styleVariant = "primary",
    headingRight,
}: FormSectionProps) => {
    const rootClasses = cx(
        rootStyleVariantMap[styleVariant],
        withDivider && theme.border,
        className
    );

    return (
        <div id={id} className={rootClasses}>
            <div
                className={cx(
                    theme.content,
                    stickyContent && theme.stickyContent
                )}
            >
                {titleLabel && (
                    <div className={theme.title}>
                        <Title
                            level={titleLevelVariantMap[styleVariant]}
                            className={titleStyleVariantMap[styleVariant]}
                        >
                            {titleLabel}
                        </Title>
                        <InfoTooltip text={tooltip} />
                        {headingRight && (
                            <div className={theme.headingRight}>
                                {headingRight}
                            </div>
                        )}
                    </div>
                )}
                {children}
            </div>
        </div>
    );
};
